import * as React from "react";

const MOBILE_WIDTH_BREAKPOINT = 768;
const MOBILE_HEIGHT_BREAKPOINT = 620;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(
    undefined,
  );

  React.useEffect(() => {
    const mql = window.matchMedia(
      `(max-width: ${MOBILE_WIDTH_BREAKPOINT - 1}px)`,
    );
    const onChange = () => {
      setIsMobile(
        window.innerWidth < MOBILE_WIDTH_BREAKPOINT ||
          (window.matchMedia("(orientation: landscape)").matches &&
            window.innerHeight < MOBILE_HEIGHT_BREAKPOINT),
      );
    };
    mql.addEventListener("change", onChange);
    window.addEventListener("orientationchange", onChange);
    setIsMobile(
      window.innerWidth < MOBILE_WIDTH_BREAKPOINT ||
        (window.matchMedia("(orientation: landscape)").matches &&
          window.innerHeight < MOBILE_HEIGHT_BREAKPOINT),
    );
    return () => {
      mql.removeEventListener("change", onChange);
      window.removeEventListener("orientationchange", onChange);
    };
  }, []);

  return !!isMobile;
}
